import { render, staticRenderFns } from "./AmazonPay.vue?vue&type=template&id=508bdca9&scoped=true&lang=pug&"
import script from "./AmazonPay.vue?vue&type=script&lang=js&"
export * from "./AmazonPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508bdca9",
  null
  
)

export default component.exports